/* jshint latedef: nofunc */
(function ( $, window, document, undefined ) {

    var defaults = {
       top_nav_links: '.portfolio-nav-links',
       sidebar_nav_links: '.js-sidebar-links',
       top_nav: '#nav-portfolio',
       sidebar_nav: '#portfolio-sidebar ul.js-nav',
       nav_header: '.navbar-header h2',
       loop_container: '#js-portfolio-loop',
       wave_effect: {
            enabled: true,
            targetId: 'nav-portfolio',
            timing: 0.75,
            ripple: '.js-ripple'
       }

    };

    var lastScroll = 0;
    var origUrl = removePageNum(location.pathname);
    var origPage = parsePageNum(location.pathname);
    var pageUrl = '/page/%d';


    function mostlyVisible(element) {
        // if ca 25% of element is visible
        var scrollPos = $(window).scrollTop();
        var windowHeight = $(window).height();
        var elTop = $(element).offset().top;
        var elHeight = $(element).height();
        var elBottom = elTop + elHeight;
        return ((elBottom - elHeight*0.25 > scrollPos) &&
                (elTop < (scrollPos+0.5*windowHeight)));
    }

    function getTaxonomy(href) {
        var terms = href.replace(/^\/|\/$/g, '').split('/');
        var tax = { taxonomy:terms[1], term: terms[2]};
        tax[terms[1]] = terms[2];
        return tax;
    }

    function removePageNum(href) {
        return href.replace(/\/$/g, '').replace(/\/page\/.*$/g, '');
    }

    function parsePageNum(href) {
        var num = parseInt(href.replace(/^.+\/page\/(\d+)\/?$/g, '$1'));
        if (isNaN(num)) {
            num = 1;
        }
        return num;
    }

    // constructor
    function Portfolio() {

        this.page =  origPage;
    }

    Portfolio.prototype.init = function(options) {
        var self = this;

        var s = this.settings = $.extend( {}, defaults, options );

        this.$topNavLinks = $(s.top_nav_links);
        this.$topNav = $(s.top_nav);
        this.$sidebarNav = $(s.sidebar_nav);
        this.$sidebarNavLinks = $(s.sidebar_nav_links);
        this.$navHeader = $(s.nav_header);
        this.$loopContainer = $(s.loop_container);

        // More button
        if (!self.$loopContainer.hasClass('js-last')) {
            self.appendMoreBtn();
        }
        self.$loopContainer.on('click', '#infinite-handle', function(e) {
            e.preventDefault();
            self.incrementPage();
            self.updatePortfolio(location.pathname, false);
        });

        // Top menu
        if (self.settings.wave_effect.enabled) {
            self.$topNavLinks.waveEffect({ targetId: 'nav-portfolio', timing: 0.75, ripple: '.js-ripple' });
        }
        self.$topNavLinks.on('click',
            function(e) {
                e.preventDefault();
                var $sideMenu = $('#'+$(this).attr('aria-controls'));
                // Get URL of first item of sidebar menu
                var href = $sideMenu.find('a').first().attr('href');
                origUrl = href;
                // update portfolio content
                self.setPage(1);
                self.updatePortfolio(href, true, 'topmenu');

                self.switchTopMenu($(this));

            });

        // Sidebar menu
        self.$sidebarNavLinks.on('click', function(e) {
            e.preventDefault();

            self.switchSideMenu($(this));

            var href = $(this).attr('href');
            origUrl = href;
            // update portfolio content
            self.setPage(1);
            self.updatePortfolio(href, true, 'sidemenu');
        });

        // History (browser back button)
        window.addEventListener('popstate', function(e) {

            if (e.state !== null) {

                var tax = getTaxonomy(location.pathname);

                if (e.state === 'topmenu') {
                    self.switchTopMenu($('#'+tax.taxonomy).children('a'));
                } else {
                    self.switchSideMenu($('#'+tax.term));
                }

                self.updatePortfolio(location.pathname, false);
            } else {

                if (location.hash.indexOf('#') === -1) {
                   window.location.reload();
                }
            }
        });

        // History (window scroll)
        $(window).scroll(function() {
            // Adjust the URL based on the top item shown
            // for reasonable amounts of items
            var scrollPos = $(window).scrollTop();
            if (Math.abs(scrollPos - lastScroll) > $(window).height()*0.1) {
              lastScroll = scrollPos;
              var changed = false;
              $(".portfolio-page-wrap").each(function(index) {
                if (mostlyVisible(this)) {
                  changed = true;
                  var pageNum = $(this).data('page-num');
                  var url = origUrl;
                  if (pageNum > 1) {
                      url += pageUrl.replace( /%d/,  pageNum);
                  }
                  history.replaceState(null, null, url);

                  return false;
                }
              });

              if (!changed && (location.hash.indexOf('#footer') === -1)) {
                  var url = origUrl;
                  if (origPage > 1) {
                    url += pageUrl.replace( /%d/,  origPage);
                  }
                  history.replaceState(null, null, url);
              }
            }
        });
    };



    Portfolio.prototype.switchSideMenu = function($link) {
        var self = this;

        self.$sidebarNavLinks.parent().removeClass('active');
        $link.parent().addClass('active');

    };

    Portfolio.prototype.switchTopMenu = function($link) {
        var self = this;

        var $prevActive =  self.$topNavLinks.filter('.active');

        var $sideMenu  = $('#'+$link.attr('aria-controls'));

        // toggle items
        $prevActive.removeClass('active');
        $link.addClass('active');

        // change background
        self.$topNav.removeClass($prevActive.parent().attr('id')).addClass($link.parent().attr('id'));
        // change header
        $(self.$navHeader).fadeOut(function() {
            $(this).text($link.text()).fadeIn(400);
        });
        // change sidebar menu
        self.$sidebarNav.slideUp(function() {
            $(this).removeClass('active');
        });

        $sideMenu.addClass('active').slideDown(function() {
            // Set first item active
            self.switchSideMenu($sideMenu.find('a').first());
        });

    };

    Portfolio.prototype.showLoader = function() {
        var self = this;
        var loader = '<span class="infinite-loader"></span>';
        self.$loopContainer.append( loader );

        self.$loader  = self.$loopContainer.find( '.infinite-loader' );
        color = self.$loader.css( 'color' );

        try {
            self.$loader.spin( 'medium-left', color );
        } catch ( error ) { }

    };
    Portfolio.prototype.hideLoader = function() {
        var self = this;
        self.$loader.hide();
    };

     Portfolio.prototype.appendMoreBtn = function() {
        var btn = '<div id="infinite-handle" class="text-center portfolio-more-block"><a href="javascript:void(0)" class="show-more">More' +
        '<svg class="icon icon-arrow-down" role="img"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="' +
        window.CT.templateUrl +
        '/dist/images/icons.svg#icon-arrow-down"></use></svg>' +
        '</a></div>';
        this.$loopContainer.append(btn);
        return this;
    };

    Portfolio.prototype.removeMoreBtn = function() {
        this.$loopContainer.find('#infinite-handle').remove();
        return this;
    };

    Portfolio.prototype.setPage = function(page) {
        this.page = page;
        return this;
    };

    Portfolio.prototype.getPage = function() {
        return this.page;
    };

    Portfolio.prototype.incrementPage = function() {
        return ++this.page;
    };

    Portfolio.prototype.updatePortfolio = function(href, updateHistory, state) {
        var self = this;
        self.removeMoreBtn();
        self.showLoader();

        $.get(
            window.CT.ajaxurl,
            {
                action : 'get_portfolio',
                href : href,
                page: self.getPage()
            },
            function( response ) {
                if (updateHistory) {
                    history.pushState(state, null, href);

                }
                var newProjects = $(response.html).hide().fadeIn('slow');
                var paginator = $(response.paginator).hide().fadeIn('slow');
                $('.wp-pagenavi').replaceWith(paginator);

                self.hideLoader();

                if (self.getPage() > 1) {
                    self.$loopContainer.append(newProjects);
                } else {
                    self.$loopContainer.html(newProjects);
                }

                // Breadcrumbs
                $('.breadcrumbs').replaceWith( response.breadcrumbs );

                // Load more btn
                if (response.last) {
                   self.$loopContainer.addClass('js-last');
                } else {
                    self.appendMoreBtn();
                }
            }
        );
    };

    window.portfolioWidget = new Portfolio();


})( jQuery, window, document );
